import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import {
  PCTableActionInputModel,
  PCTableFieldModel,
} from '../../models/pc-table-action-input-model';
import * as _ from 'lodash-es';
import { DatePipe } from '@angular/common';
import { ModalConfirm } from '../../models/modal-confirm';
import { Field } from '../../models/entity-defin';
import { forkJoin, of } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { FocusableHTMLElement } from '../../interfaces/focusable-html-element';
import { FormControl, FormGroup } from '@angular/forms';
import { BuyImportRequestDrugModal } from '../../models/buy-import-modal';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { InventoryTransferDetailModal, InventoryTransferModal } from '../../models/Inventory-transfer-modal';

@Component({
  selector: 'app-inventory-transfer',
  templateUrl: './inventory-transfer.component.html',
  styleUrl: './inventory-transfer.component.css'
})
export class InventoryTransferComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private renderer: Renderer2,
    public datepipe: DatePipe,
    public calendarService: NewCalendarService,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == '+') {
        this.openAddModal = true;
        this.thisValue = undefined;
      }
    });
    this.getSearchEntity();
    this.getStocks();
    this.searchRequestModel = new PCSearchRequestModel();
    this.requestModel = new PCSearchRequestModel();
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Create',
          className: 'btn-outline-primary',
          icon: 'bx bx-plus',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    if (this.endPoint != null) {
      this.action.title = this.endPoint;
    }
    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });
  }

  @Input() sourceStockId?: string;

  public endPoint: string = `InventoryTransfer`;
  public data?: PCTableInputModel;
  public destinationMessage: string = ``;
  public paging?: TabelPaging;
  public action: PCTableActionInputModel;
  public fields: Field[] = [];
  public modalFields: Field[] = [];
  public stockList: any[] = [];
  public secondStockList: any[] = [];
  public openAddModal: boolean = false;
  public modalDeleteConfirm: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public breadCrumb: string = '';

  public drugSearchForm: FormGroup;
  public activeSerch: boolean = true;
  public searchLoading: boolean = false;
  public modalIsOpen: boolean = false;
  public searchRequestModel: PCSearchRequestModel;
  public searchData?: PCTableInputModel;
  public searchPaging: any;
  public editIndex: number | null = null;

  private rememberItem?: FocusableHTMLElement;
  private focusableItems: FocusableHTMLElement[] = [];
  public newItem: InventoryTransferModal = new InventoryTransferModal();
  public newDrug: InventoryTransferDetailModal = new InventoryTransferDetailModal();
  public searchFields: any[] = [];

  public monthName: string = '';
  public requestModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public loading: boolean = false;
  public thisValue: any;
  public justShow: boolean = false;

  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;
  @ViewChild(PCTableComponent) pCTableComponent!: PCTableComponent;
  @ViewChild('settingsModal') settingsModal!: any;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild('AddInventoryTransferModal') AddInventoryTransferModal!: ElementRef;

  public confirmModal: ModalConfirm = new ModalConfirm();

  public ngOnInit(): void {

    this.drugSearchForm.get('drugBrandName')?.valueChanges.subscribe(value => {
      this.searchDrug(value);
    });

    this.action.title = this.endPoint;

    this.generateUrl();
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {


            this.map(dataResult);

            this.paging = this.responseService.customizePaging(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  private map(dataResult) {
    let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

    if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount != 0) {
      this.requestModel.pageNumber = 1;
      this.getSingleData();
    }
    this.data = new PCTableInputModel(
      dataResult.data?.items.map((current) => ({
        ...current,

        showSeeButton: current.status == 0 ? true : false,
        showSendButton: current.status == 0 ? true : false,
        showDeliverButton: current.status == 2 ? true : false,
        showDeleteButton: current.status != 6 ? true : false,
      })),
      [
        {
          name: 'See',
          className: 'btn-outline-primary',
          icon: 'fa fa-eye',
        },
        {
          name: 'Send',
          className: 'btn-outline-warning',
          icon: 'fa-solid fa-paper-plane',
          condition: 'showSendButton',
        },
        {
          name: 'delivery',
          className: 'btn-outline-info',
          icon: 'fa-solid fa-clipboard-check',
          condition: 'showDeliverButton',

        },
        {
          name: 'Delete',
          className: 'btn-outline-danger',
          icon: 'bx bx-trash',
          condition: 'showDeleteButton',

        },
      ],
      true,
      firstItemOnPage,
      this.requestModel.orderBy,
      this.requestModel.direction
    );
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {

            this.map(result);

            const matTable = document.querySelector('.table-responsive');
            if (matTable != null) {
              matTable.scrollTop = 0;
            }

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          this.endPoint
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public clearForm(inputElement: any) {
    try {
      for (let element of inputElement) {
        element.defValue = null;
      }
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public submitDelete() {
    try {
      this.loading = true;
      let url = `${this.endPoint}/${this.thisValue.id}`;

      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            this.getSingleData();
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, false);
      this.loading = false;
    }
  }

  public createJson(inputElement: Field[]) {
    var backentJson = {};
    for (let index = 0; index < inputElement.length; index++) {
      const element = inputElement[index];

      backentJson[element.fieldName] = element.defaultValue;
    }
    return backentJson;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;

        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
          this.requestModel.orderBy = event.data;
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
          this.requestModel.orderBy = event.data;
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        } else {
          this.requestModel.direction = 'asd';
          this.requestModel.orderBy = '';
        }
        this.searchDrug(this.newDrug.drugName!);
        this.generateUrl();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Create':
        this.justShow = false;
        this.newItem = new InventoryTransferModal();
        this.openAddTransfer();
        break;
      case 'SaveAdd':
        this.openAddModal = false;
        // this.submitAdd(event.data);
        break;
      case 'See':
        this.justShow = true;
        this.openModal(event.data);
        this.newItem.status = -2;
        break;
      case 'Send':
        this.justShow = false;
        this.openModal(event.data);
        break;

      case 'delivery':
        this.justShow = false;
        this.openModal(event.data);
        break;

      case 'Edit':
        this.thisValue = event.data;
        this.openAddModal = true;
        this.modalFields = _.cloneDeep(
          this.fields.filter((current) => current.isEditable)
        );
        break;
      // case 'SaveEdit':
      //   this.openAddModal = false;
      //   this.submitEdit(event.data);
      //   break;
      case 'Close':
        this.thisValue = undefined;
        this.openAddModal = false;
        break;
      case 'Delete':
        this.modalDeleteConfirm = true;
        this.thisValue = event.data;
        break;
      case 'NotDelete':
        this.modalDeleteConfirm = false;
        this.thisValue = undefined;
        break;
      case 'ConfirmDelete':
        this.modalDeleteConfirm = false;
        this.submitDelete();
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      default:
        break;
    }
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.searchLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.newDrug.drugName!);
        break;
      case 'Paging':
        this.searchLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.newDrug.drugName!);
        break;
      case 'PageSize':
        this.searchLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.newDrug.drugName!);
        break;
      case 'SelectItem':
        const selectedDrug = event.data;
        this.searchLoading = false;
        this.drugSearchForm.patchValue({
          drugBrandName: selectedDrug.brandName,
          inventoryDetailId: selectedDrug.id
        });
        setTimeout(() => {
          this.newDrug.drugName = selectedDrug.brandName;
          this.newDrug.inventoryDetailId = selectedDrug.id;
        });
        this.modalIsOpen = false;
        break;
      default:
        break;
    }
  }

  public validationDrugItems(): boolean {
    const requiredMessage = 'وارد کردن این فیلد اجباری می باشد';
    let isSucceed = true;

    if (this.newDrug == null) {
      return false;
    }

    if (
      this.newDrug.drugName == null ||
      this.newDrug.drugNameHint == ''
    ) {
      this.newDrug.drugNameHint = requiredMessage;
      isSucceed = false;
    } else {
      this.newDrug.drugNameHint = undefined;
    }

    if (
      this.newDrug.count == null ||
      this.newDrug.countHint == ''
    ) {
      this.newDrug.countHint = requiredMessage;
      isSucceed = false;
    } else {
      this.newDrug.countHint = undefined;
    }

    if (
      this.newDrug.expireDate == null ||
      this.newDrug.expireDateHint == ''
    ) {
      this.newDrug.expireDateHint = requiredMessage;
      isSucceed = false;
    } else {
      this.newDrug.expireDateHint = undefined;
    }

    return isSucceed;
  }


  public addDrugToList(): void {
    if (!this.validationDrugItems()) {
      return;
    }

    const drugName = (this.newDrug.drugName || '').trim();
    const countStr = (this.newDrug.count || '').toString();
    const expireDate = this.newDrug.expireDate;
    const inventoryDetailId = this.newDrug.inventoryDetailId;

    const newRecord = {
      drugName: drugName,
      count: countStr,
      expireDate: expireDate,
      inventoryDetailId: inventoryDetailId
    };

    if (this.editIndex !== null) {
      this.newItem.details[this.editIndex] = newRecord;
      this.editIndex = null;
    } else {
      this.newItem.details.push(newRecord);
    }

    this.newDrug = {
      drugName: '',
      count: '',
      expireDate: '',
      inventoryDetailId: '',
    };
  }

  public clearEditItem(): void {
    this.newDrug = new InventoryTransferDetailModal();
    this.newItem = new InventoryTransferModal();

    this.editIndex = null;
  }


  public changeTime(value: any): string | null {
    var timeArray = value.split(':');
    var date = new Date();
    date.setHours(timeArray[0]);
    date.setMinutes(timeArray[1]);
    date.setSeconds(0);

    return this.datepipe.transform(date, 'HH:mm:ss');
  }

  public SubmitSetting() {
    if (this.pcTableComponent) {
      this.pcTableComponent.RebuildColumn();
      this.modalService.dismissAll();
    } else {
      console.error('PCTableComponent not found');
    }
  }

  public openAddTransfer() {
    this.modalService.open(this.AddInventoryTransferModal, {
      size: 'xl',
      backdrop: 'static'
    });
  }

  public openModal(item: any) {
    this.newItem = new InventoryTransferModal();
    this.newItem.id = item.id;
    this.newItem.description = item.description;
    this.newItem.destinationStockId = item.destinationStockId;
    this.newItem.sourceStockId = item.sourceStockId;
    this.newItem.status = _.cloneDeep(item.status);
    this.filterStocks();
    this.getDrugList(item.id);

    this.modalService.open(this.AddInventoryTransferModal, {
      size: 'xl',
      backdrop: 'static'
    });
  }

  public getDrugList(id: any) {
    this.loading = true;
    try {
      let url = `InventoryTransferDetail/GetDetailsByTransferId/${id}`;

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          result.data = result.data ?? [];

          if (result.succeeded) {
            this.newItem.details = result.data;
          } else {
            this.logger.addBackEndMessage(result);
          }

          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public remove(item: any): void {
    try {

      this.newItem.details = this.newItem.details
        .filter((current) => current.id != item.id)

    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public editDrug(item: any, index: number): void {
    this.newDrug = { ...item };
    this.editIndex = index;
  }


  public searchDrug(drugName?: string): void {
    try {
      this.searchLoading = true;

      if (!drugName) {
        this.searchLoading = false;
        return;
      }

      if (!this.newItem.sourceStockId) {
        this.logger.addWarning('لطفاً ابتدا انبار مبدا را انتخاب کنید.', false);
        this.searchLoading = false;
        return;
      }


      if (this.modalIsOpen === false) {
        this.modalIsOpen = true;
      }

      const url = `InventoryTransfer/SearchInventoryDetails/${this.newItem.sourceStockId}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${drugName}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, 'Search Drug (By Stock)');

          if (result.succeeded) {
            let firstItemOnPage = result.data?.firstItemOnPage ?? 1;

            if (
              result.data?.pageCount !== 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }


            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => {
          this.searchLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public filterStocks(): void {
    try {
      this.secondStockList = this.stockList.filter((current) => current.id != this.newItem.sourceStockId)

    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public getStocks(): void {
    try {
      this.loading = true;
      let url = `Stock?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.stockList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.title,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public nextFocus() {
    if (this.focusableItems.length == 0) {
      return;
    }

    let focusedElement = document.activeElement;

    let currentItemInArray = this.focusableItems.find(
      (current) =>
        current.element.id == focusedElement?.id &&
        current.element.classList == focusedElement?.classList
    );

    if (currentItemInArray == null && this.rememberItem != null) {
      if (
        this.rememberItem.element.className.indexOf('drop-down-box') >= 0 &&
        this.rememberItem.element.className.indexOf('drop-down-box-open') >= 0
      ) {
        return;
      } else {
        currentItemInArray = this.rememberItem;
      }
    }

    const currentItemIndex =
      currentItemInArray == undefined ? 0 : currentItemInArray.index + 1;

    const nextItemIndex =
      currentItemIndex == this.focusableItems.length ? 7 : currentItemIndex;

    const needFocus = this.focusableItems[nextItemIndex];

    needFocus.element.focus();
    this.rememberItem = needFocus;

    if (needFocus.element instanceof HTMLInputElement) {
      needFocus.element.select();
    }
  }

  private validateTransferData(): boolean {
    if (!this.newItem.sourceStockId || !this.newItem.destinationStockId) {
      this.logger.addWarning('انبار مبدا و مقصد باید مشخص شوند.', false);
      return false;
    }

    if (this.newItem.details.length === 0) {
      this.logger.addWarning('لطفاً حداقل یک دارو اضافه کنید.', false);
      return false;
    }

    return true;
  }

  public sendTransfer(): void {
    try {
      this.loading = true;

      const backendJson = {
        id: this.newItem.id,
        details: this.newItem.details.map(drug => ({
          id: drug.id,
          drugName: drug.drugName,
          count: drug.count,
          expireDate: drug.expireDate,
          inventoryDetailId: drug.inventoryDetailId
        }))
      };

      const url = 'InventoryTransfer/SendTransferFromSource';

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.loading = true;
          this.modalSuccessConfirm = true;
          this.getSingleData();
          this.modalService.dismissAll();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.logger.addError('در ارسال حواله از انبار مبدأ خطایی رخ داده است.', false);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      this.loading = false;
    }
  }

  public deliveryTransfer(): void {
    try {
      this.loading = true;

      const backendJson = {
        id: this.newItem.id,
        details: this.newItem.details.map(drug => ({
          id: drug.id,
          drugName: drug.drugName,
          count: drug.count,
          expireDate: drug.expireDate,
          inventoryDetailId: drug.inventoryDetailId
        }))
      };

      const url = 'InventoryTransfer/DeliveryToDestinationStock';

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.loading = true;
          this.modalSuccessConfirm = true;
          this.getSingleData();
          this.modalService.dismissAll();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.logger.addError('در دریافت حواله از انبار مقصد خطایی رخ داده است.', false);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      this.loading = false;
    }
  }



  public saveInventoryTransfer(): void {
    try {
      if (!this.validateTransferData()) {
        this.loading = false;
        return;
      }

      this.loading = true;

      const backendJson = {
        sourceStockId: this.newItem.sourceStockId,
        destinationStockId: this.newItem.destinationStockId,
        description: this.newItem.description,
        details: this.newItem.details.map(drug => ({
          drugName: drug.drugName,
          count: drug.count,
          expireDate: drug.expireDate,
          inventoryDetailId: drug.inventoryDetailId
        }))
      };

      const url = 'InventoryTransfer/TransferImport';

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.newItem = this.newItem;
          this.loading = true;
          this.modalSuccessConfirm = true;
          this.getSingleData();
          this.modalService.dismissAll();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.logger.addError('در ثبت اطلاعات خطایی رخ داده است.', false);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      this.loading = false;
    }
  }

  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          `InventoryDetail`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            setTimeout(() => {
              if (this.searchBoxComponent) {
                this.searchBoxComponent.InitPage();
              } else {
                console.error('PCTableComponent not found');
              }
            }, 2);
            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
  }
}



